var map = {
	"./CommentCount.importable": [
		3215,
		1983,
		4889,
		3215
	],
	"./DiscussionContainer.importable": [
		6916,
		1983,
		4889,
		8680,
		4891,
		6916
	],
	"./DocumentBlockComponent.importable": [
		1053,
		1983,
		1053
	],
	"./EditionDropdown.importable": [
		6965,
		1983,
		6965
	],
	"./GetMatchStats.importable": [
		3639,
		1983,
		4889,
		3639
	],
	"./InstagramBlockComponent.importable": [
		343,
		1983,
		343
	],
	"./Links.importable": [
		588,
		1983,
		4889,
		1924
	],
	"./MapEmbedBlockComponent.importable": [
		9641,
		1983,
		4415,
		9641
	],
	"./MostViewedRightWrapper.importable": [
		5024,
		1983,
		4889,
		8680,
		602
	],
	"./OnwardsLower.importable": [
		3213,
		1983,
		4889,
		3213
	],
	"./OnwardsUpper.importable": [
		4999,
		1983,
		4889,
		7752,
		4999
	],
	"./RichLinkComponent.importable": [
		7051,
		1983,
		4889,
		7051
	],
	"./SpotifyBlockComponent.importable": [
		9776,
		1983,
		7754,
		9776
	],
	"./SubNav.importable": [
		6348,
		1983,
		6348
	],
	"./VideoFacebookBlockComponent.importable": [
		5585,
		1983,
		45,
		5585
	],
	"./VineBlockComponent.importable": [
		8080,
		1983,
		8080
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8602;
module.exports = webpackAsyncContext;